import icon1 from '../Icons/landingpages/PartnerWithUs/1.svg'
import icon2 from '../Icons/landingpages/PartnerWithUs/2.svg'
import icon3 from '../Icons/landingpages/PartnerWithUs/3.svg'
import LeftCallAction from '../Icons/landingpages/PartnerWithUs/left-call-action.svg'
import RightCallAction from '../Icons/landingpages/PartnerWithUs/right-call-action.svg'

import ShallowHeader from '../components/ShallowHeader'
import { Container } from '../components/Container'
import { useRef } from 'react'
import Hero from '../components/LandingPages/PartnerWithus/Hero'
import FeatureBoxWrapper from '../components/FeatureBoxWrapper'
import FeatureBox from '../components/FeatureBox'
import { GeneralAPI } from '../apis/GeneralAPI'
import GradientButton from '../components/Buttons/GradientButton'
import { ModalStore } from '../state/ModalStore'
import PartnerWithUsModal from '../components/Modals/PartnerWithUsModal'
import Footer from '../components/Footer'
// import Navigation from '../components/LandingPages/PartnerWithus/Navigation'

const features = [
    {
        Icon: icon1,
        heading: 'Streamlined campaign management',
    },
    {
        Icon: icon2,
        heading: 'Enhanced real estate investment tracking',
    },
    {
        Icon: icon3,
        heading: 'Data-driven insights for smarter decisions',
    },
]

const PartnerWithUs = ({ partners, data }) => {
    const formRef = useRef(null)

    const addModal = ModalStore((state) => state.add)

    const handlePartnerClick = () => {
        addModal(<PartnerWithUsModal />)
    }

    const handleApplyNow = () => {
        if (formRef.current) {
            formRef.current.scrollIntoView({ behavior: 'smooth' })
        }
    }

    return (
        <>
            <ShallowHeader
                metaTitle={'Partner With Us'}
                meta={data?.yoast_head}
            />
            <div className="space-y-10 md:space-y-10 z-10">
                <div className="relative z-0">
                    <Hero onApplyClick={handleApplyNow} />
                </div>

                <div className="py-6 container m-auto text-xl text-center max-w-3xl px-10">
                    At{' '}
                    <span className="olm-gradient-text font-bold">
                        Open Letter Marketing
                    </span>
                    ,
                    <br className="md:hidden" /> we collaborate with innovative{' '}
                    <br className="md:hidden" /> platforms{' '}
                    <br className="hidden md:block" />
                    that streamline your real <br className="md:hidden" />{' '}
                    estate marketing and investing efforts.
                    <br className="hidden md:block" />
                    Explore how each partner <br className="md:hidden" />{' '}
                    contributes to your success.
                </div>

                <div className="bg-light-yellow-gradient-transparent py-16 pb-0 rounded-10xl">
                    <div className="bg-[url('/assets/landing/partner-with-us/bg.svg')] bg-no-repeat bg-center">
                        <Container footer={false}>
                            <div className="max-w-5xl mx-auto px-4 md:px-0">
                                <FeatureBoxWrapper>
                                    {partners.map((partner, i) => {
                                        return (
                                            <FeatureBox key={i}>
                                                <div className="flex flex-col h-full justify-between space-y-6 md:space-y-10 text-center text-black">
                                                    {' '}
                                                    {/* Reduced space-y on mobile */}
                                                    <h3 className="block font-semibold py-2 text-xs md:text-sm bg-black text-white rounded-md uppercase">
                                                        {' '}
                                                        {/* Made text size responsive */}
                                                        {partner.title}
                                                    </h3>
                                                    <div className="flex justify-center items-center h-20 md:h-24">
                                                        {' '}
                                                        {/* Adjusted height for mobile */}
                                                        <img
                                                            src={
                                                                partner.logo.url
                                                            }
                                                            alt={
                                                                partner.logo.alt
                                                            }
                                                            title={
                                                                partner.logo
                                                                    .title
                                                            }
                                                            className="mx-auto max-h-16 md:max-h-20"
                                                        />
                                                    </div>
                                                    {/* Heading and Description */}
                                                    <div className="flex-1 space-y-4 md:space-y-10">
                                                        {' '}
                                                        {/* Adjusted spacing on mobile */}
                                                        <p className="font-bold h-14 text-black text-lg md:text-xl">
                                                            {' '}
                                                            {/* Made text size responsive */}
                                                            {partner.heading}
                                                        </p>
                                                        <p className="text-xs md:text-sm font-semibold text-gray-600">
                                                            {' '}
                                                            {/* Made text size responsive */}
                                                            {
                                                                partner.description
                                                            }
                                                        </p>
                                                    </div>
                                                    {/* Button */}
                                                    <div>
                                                        <a
                                                            href={
                                                                partner.button
                                                                    .url
                                                            }
                                                            target={
                                                                partner.button
                                                                    .target
                                                            }
                                                            className="olm-gradient font-semibold block w-full max-w-full hover:bg-none hover:bg-secondary shadow-lg text-white px-2 md:px-4 py-2 md:py-4 rounded-md">
                                                            {
                                                                partner.button
                                                                    .title
                                                            }
                                                        </a>
                                                    </div>
                                                    {/* <div>
                                                        <img
                                                            src={partner.image}
                                                            alt={partner.title}
                                                            className="mx-auto mt-4 max-w-full"
                                                        />
                                                    </div> */}
                                                </div>
                                            </FeatureBox>
                                        )
                                    })}
                                </FeatureBoxWrapper>
                            </div>
                        </Container>
                    </div>
                </div>

                <section className="bg-gradient-to-b from-gray-50 to-white py-16 relative">
                    <div className="absolute w-48 md:w-72 md:block z-10 left-0 top-[60%] md:top-1/2 transform -translate-y-1/2">
                        <LeftCallAction />
                    </div>
                    <div className="absolute w-48 md:w-72 md:block right-0 top-[60%] md:top-1/2 transform -translate-y-1/2">
                        <RightCallAction />
                    </div>
                    <div className="max-w-5xl mx-auto text-center z-20 relative">
                        <div className=" px-10 md:px-0 ">
                            <h2 className="text-3xl md:text-4xl font-bold mb-6">
                                Ready To{' '}
                                <span className="text-orange-500">
                                    Elevate Your Real Estate Marketing?
                                </span>
                            </h2>
                            <p className="text-lg text-gray-700 mb-12">
                                At{' '}
                                <span className="font-bold text-orange-500">
                                    Open Letter Marketing
                                </span>
                                , we’ve teamed up with industry leaders to give{' '}
                                <br /> real estate professionals every tool they
                                need to succeed.
                            </p>
                        </div>
                        <div className="relative">
                            {/* <div className="absolute w-72 border md:hidden left-0 top-1/2 transform -translate-y-1/2">
                            <LeftCallAction />
                        </div>
                        <div className="absolute w-48 border md:hidden right-0 top-1/2 transform -translate-y-1/2">
                            <RightCallAction />
                        </div> */}
                            <div className="relative z-20 px-10 md:px-0 ">
                                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-12">
                                    {features.map((feature, i) => {
                                        return (
                                            <div
                                                className="olm-gradient px-2 py-6 rounded-lg shadow-lg"
                                                key={i}>
                                                <div className="p-6 rounded-lg text-center space-y-4">
                                                    <div className="flex justify-center">
                                                        <feature.Icon />
                                                    </div>
                                                    <h3 className="text-white text-xl">
                                                        {feature.heading}
                                                    </h3>
                                                </div>
                                            </div>
                                        )
                                    })}
                                </div>
                                <div className="max-w-md m-auto">
                                    <GradientButton
                                        onClick={handlePartnerClick}
                                        className="bg-orange-500 hover:bg-orange-600 text-white py-3 px-8 rounded-full font-bold shadow-lg">
                                        Partner With Us
                                    </GradientButton>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />
            </div>
        </>
    )
}

export async function getStaticProps() {
    const page = await GeneralAPI.getPageBySlug('/partner-with-us')
    const data = page ? page[0] : {}
    const {
        data: { partners },
    } = await GeneralAPI.getACFOptions('options/partners')

    return {
        props: {
            isComponent: false,
            partners,
            data,
        },
        revalidate: 10, // In seconds
    }
}

export default PartnerWithUs
